import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
const Hero = () => {
  const features = ["针对小语种优化", "格式90%高还原度", "专业翻译引擎"];
  return <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/10 pointer-events-none" />
      
      <div className="max-w-7xl mx-auto relative">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-foreground mb-6 leading-tight animate-fade-in mx-[2px] md:text-5xl">
            快速理解小语种PDF，
            <span className="text-primary bg-gradient-to-r from-primary via-primary-light to-primary bg-clip-text text-transparent animate-glow">
              从此不求人
            </span>
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8 leading-relaxed animate-slide-up">上传文档 → 智能识别 → 高保真翻译 → 格式还原输出 → 多语种对照导出，批量处理小语种文档，专为出海企业设计。</p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12 animate-scale-in">
            <Button
              size="lg"
              className="px-8 py-3 text-lg shadow-elegant hover:shadow-glow transition-all duration-300 hover:scale-105"
              onClick={() => window.open("/translator", "_blank")}
            >
              立即试用
            </Button>
            <Button variant="outline" size="lg" className="px-8 py-3 text-lg border-primary/20 hover:border-primary/40 hover:bg-primary/5 transition-all duration-300 hover:scale-105">
              查看案例
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
            {features.map((feature, index) => <div key={index} className="flex items-center space-x-2">
                <CheckCircle className="w-4 h-4 text-primary" />
                <span>{feature}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;